import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Export from '../components/Export';
import { doFlash } from '../actions/flash';
import { fetchTeachers } from '../actions/classrooms';

let mapStateToProps = function(state) {
	return {
		authToken: state.auth.token,
		selectedClassroom: state.classrooms.selected,
		selectedDistrict: state.districts.selected,
		selectedSchool: state.schools.selected,
		teachers: state.classrooms.teachers
	};
};

let mapDispatchToProps = {
	doFlash,
	fetchTeachers
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(Export);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/Export.jsx